module.exports = __webpack_public_path__ + "img/bg-noise.29f36df.png";